/*
 * @Description:
 * @Author: PF
 * @Date: 2023-01-29 18:33:45
 * @LastEditors: PF
 * @LastEditTime: 2026-09-08 17:54:11
 * @FilePath: \ZHXY_VUE3.0\src\main.ts
 */
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import VueDOMPurifyHTML from 'vue-dompurify-html'
import VueUeditorWrap from 'vue-ueditor-wrap'
import VueCookies from 'vue-cookies'
import ElementPlus from 'element-plus'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import * as echarts from 'echarts'
import 'echarts-liquidfill'
import 'moment/locale/zh-cn' // 引入中文语言包
import '@/assets/js/ployfill' // 注意文件路径

import zhCn from '@/assets/js/zh-cn'
import 'dayjs/locale/zh-cn'
import 'element-plus/dist/index.css'
import '@/assets/css/main.less'
import '@/assets/css/css-vars.css'
import '@/assets/iconfont/iconfont.css'

// 公共配色
import '@/assets/css/peise.less'
// 公共样式
import '@/assets/css/liebiao.less'
import '@/assets/css/windowsize.css'
import '@/assets/css/tanchuang.less'

// 系部空间
import '@/assets/css/xibukongjian/peise.less'
import '@/assets/css/xibukongjian/liebiao.less'

// 富文本编辑器
import { QuillEditor } from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css'

import { fetchDynamicRoutes } from './utils/routeGenerator'

// main.js —— 全局兜底，一次性让所有 el-dialog 传送到 body
import { ElDialog } from 'element-plus'
ElDialog.props.appendToBody.default = true

// office
const app = createApp(App)

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}
app.use(ElementPlus, {
  locale: zhCn
})

app.use(VueDOMPurifyHTML)
app.use(VueUeditorWrap)
app.config.globalProperties.cookies = VueCookies

app.config.globalProperties.$echarts = echarts

app.use(store)
app.use(router)
app.component('QuillEditor', QuillEditor)
app.mount('#app')